import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

interface Props {
  onCleanupComplete: () => void;
}

export function CleanupFamilyTransfersButton({ onCleanupComplete }: Props) {
  const [isProcessing, setIsProcessing] = useState(false);
  const { toast } = useToast();

  const handleCleanup = async () => {
    if (!confirm('This will soft-delete all Comal County records where the grantor and grantee share the same last name (family-to-family transfers). Continue?')) {
      return;
    }

    setIsProcessing(true);
    try {
      const { data, error } = await supabase.functions.invoke('cleanup-family-transfers');
      
      if (error) throw error;

      toast({
        title: "Cleanup complete",
        description: data.message,
      });
      
      onCleanupComplete();
    } catch (error) {
      console.error('Error cleaning up family transfers:', error);
      toast({
        title: "Error",
        description: "Failed to clean up family transfers. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Button 
      onClick={handleCleanup}
      disabled={isProcessing}
      variant="outline"
    >
      {isProcessing ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Cleaning up...
        </>
      ) : (
        "Cleanup Family Transfers"
      )}
    </Button>
  );
}
